import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import LivecycleSdk from '@livecycle/sdk';

LivecycleSdk.init();

export const externalModules = [
  [
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      connectInZone: true,
    }),
  ],
];
